import { useState } from "react";
import { Infinity as InfinityIcon } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Card, inputCls, btn, errMsg } from "./ui";

export function LifetimeGrant({ org, onUpdated }) {
  const [licenses, setLicenses] = useState(org.contract?.licenses || org.dentists || 1);
  const [reason, setReason] = useState("");
  if (org.contract?.lifetime && org.contract.status === "active") return null;
  const grant = async () => {
    if (!window.confirm(`Grant ${org.name} lifetime free access for ${licenses} licenses? Any current contract moves to history.`)) return;
    try {
      onUpdated((await api.post(`/admin/institutions/${org.id}/lifetime`, { licenses, reason })).data);
      toast.success("Lifetime free access granted");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Card className="border-violet-200 bg-violet-50/40" data-testid="lifetime-grant">
      <p className="font-heading font-semibold text-violet-800 flex items-center gap-2"><InfinityIcon className="w-4 h-4" /> Lifetime free access (optional)</p>
      <p className="text-xs text-slate-600 mt-1">Activates a complimentary contract with no expiry and no payment. You can still change licenses or suspend it later.</p>
      <div className="flex flex-wrap gap-2 mt-3">
        <input type="number" min={1} className={`${inputCls} max-w-[140px]`} value={licenses} onChange={(e) => setLicenses(Number(e.target.value))} data-testid="lifetime-licenses" />
        <input className={`${inputCls} flex-1 min-w-[200px]`} placeholder="Reason (saved in the audit log)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="lifetime-reason" />
        <button type="button" className={`${btn} bg-violet-600 text-white hover:bg-violet-700`} disabled={reason.trim().length < 3} onClick={grant} data-testid="lifetime-grant-btn">Grant lifetime access</button>
      </div>
    </Card>
  );
}
